import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.014 1.251a1 1 0 0 1 .129.013l.013.003a1 1 0 0 1 .114.034l.043.02a1 1 0 0 1 .078.041l.036.023a1 1 0 0 1 .103.085l6 6a1 1 0 0 1 .084.102l.023.036q.023.038.042.078l.02.043a.8.8 0 0 1 .049.256L20.75 8v12A2.75 2.75 0 0 1 18 22.75H6A2.756 2.756 0 0 1 3.25 20V4A2.75 2.75 0 0 1 6 1.25h8zM6 2.75A1.25 1.25 0 0 0 4.75 4v16c0 .686.564 1.25 1.25 1.25h12A1.25 1.25 0 0 0 19.25 20V8.75H14a.75.75 0 0 1-.75-.75V2.75zm8.75 4.5h3.44l-3.44-3.44z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.386 10.476a1 1 0 0 1 1.228 0l3.5 2.723a1 1 0 0 1 .386.789v5.01a1 1 0 0 1-.293.708l-.073.066A1 1 0 0 1 15.5 20h-7a1 1 0 0 1-.634-.227l-.073-.066a1 1 0 0 1-.293-.707v-5.011a1 1 0 0 1 .386-.79zM9 14.231V18.5h1.5v-2.5a1 1 0 0 1 .898-.995l.102-.005h1l.102.005a1 1 0 0 1 .898.995v2.5H15V14.23l-3-2.333z"
    }, null, -1)
  ])))
}
export default { render: render }